import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';

import { BaseComponentClassDirective } from '~shared/classes/base-component.class';
import { AccountManagementDataService } from '../../services/account-management-data.service';
import { IAccountDetailsSection } from '../../models/account-info.model';
import { ExpiredChangeEmailRequestService } from '../../services/expired-change-email-request.service';

@Component({
  selector: 'app-account-details',
  templateUrl: './account-details.component.html',
  styleUrls: ['./account-details.component.scss'],
})
export class AccountDetailsComponent extends BaseComponentClassDirective implements OnInit {
  public templateOptions: {
    sectionList$: Observable<IAccountDetailsSection[]>
  };

  constructor(
    private accountManagementDataService: AccountManagementDataService,
    private expiredChangeEmailRequestService: ExpiredChangeEmailRequestService,
  ) {
    super();
  }

  public ngOnInit(): void {
    this.templateOptions = {
      sectionList$: this.accountManagementDataService.getAccountDetailsList(),
    };

    this.expiredChangeEmailRequestService.checkExpiredRequest();
  }
}
